export function EditTable (pEditor, pTable)
{
  var showHideTablesBordersButtonStateTM = null;

  var checkTableTag = /^table$/i,
      checkThTdTags = /^(th|td)$/i;

  this.queryBasicEditTable = (pButton, command) =>
  {
    var currentRange = pEditor.range.getCurrent();

    if (currentRange)
    {
      return (pEditor.helpers.element.getParentElementNameByTagsNames(currentRange, checkThTdTags)) ? true : false;
    }
    else
    {
      return false;
    }
  };


  this.basicEditTable = (pButton, command) =>
  {
    var i, j;
    var parentTag, parentTagTR, parentTagTable;
    var newRow, newRowIndex, currentRowIndex;
    var newCell, newCellIndex, currentCellIndex, replaceCell, realCellsCount, realNewCellIndex;
    var currentColspan, currentRowspan;
    var newCursorPointRow, newCursorPointCell;
    var isTableNoCells;
    var stylesList = [];
    var currentRange = pEditor.range.getCurrent();
    var currentSelection = pEditor.range.selection.getCurrent();

    if (currentRange && currentSelection)
    {
      pEditor.undoRedo.isStopSaveUndo = true;
      pEditor.contentChecker.setExcludeWordCheck();

      parentTag = pEditor.helpers.element.getParentElementByTagsNames(currentRange, checkThTdTags);

      if (parentTag)
      {
        parentTagTR = parentTag.parentNode;
        parentTagTable = pEditor.helpers.element.getParentElementByTagsNames(currentRange, checkTableTag);
        currentRowIndex = parentTagTR.rowIndex;
        currentCellIndex = parentTag.cellIndex;

        if (command.element == 'table')
        {
          if (command.action == 'delete')
          {
            parentTagTable.parentNode.removeChild(parentTagTable);
          }
        }
        else if (command.element == 'row')
        {
          if (command.action == 'add')
          {
            collectStyles(true);
            currentRowspan = parentTag.getAttribute('rowspan', 0);
            newRowIndex = (command.position == 'after') ? currentRowIndex + ((currentRowspan) ? currentRowspan * 1 : 1) : currentRowIndex;
            newRow = parentTagTable.insertRow(newRowIndex);
            realCellsCount = getRealCellsCount();

            for (i = 0; i < realCellsCount; i++)
            {
              newCell = newRow.insertCell(i);
              tuningNewCell(true, currentRowIndex, i);
            }
          }
          else
          {
            if (parentTagTable.rows.length > 1)
            {
              newCursorPointRow = (currentRowIndex == parentTagTable.rows.length - 1) ? currentRowIndex - 1 : currentRowIndex + 1;
              newCursorPointCell = (parentTagTable.rows[newCursorPointRow].cells[currentCellIndex]) ? currentCellIndex : 0;
              pEditor.range.setCursorPoint(parentTagTable.rows[newCursorPointRow].cells[newCursorPointCell], false, currentSelection, currentRange);
            }

            parentTagTable.deleteRow(currentRowIndex);

            if (!parentTagTable.rows.length)
            {
              parentTagTable.parentNode.removeChild(parentTagTable);
            }
            else
            {
              pEditor.helpers.fixers.setFixGeckoTables({isBoth: true, newTable: parentTagTable});
              pEditor.undoRedo.isStopSaveUndo = true;
              pEditor.contentChecker.setExcludeWordCheck();
            }
          }
        }
        else
        {
          if (command.action === 'add')
          {
            collectStyles(false);
            currentColspan = parentTag.getAttribute('colspan', 0);
            newCellIndex = (command.position === 'after') ? currentCellIndex + ((currentColspan) ? currentColspan * 1 : 1) : currentCellIndex;
            realCellsCount = getRealCellsCount();

            for (i = 0; i < parentTagTable.rows.length; i++)
            {
              realNewCellIndex = newCellIndex;

              for (j = 0; j < realNewCellIndex; j++)
              {
                currentColspan = parentTagTable.rows[i].cells[j].getAttribute('colspan', 0);
                realCellsCount -= (currentColspan) ? currentColspan - 1 : 0;
              }

              newCell = parentTagTable.rows[i].insertCell(realNewCellIndex);

              if (newCell[(command.position === 'after') ? 'previousElementSibling' : 'nextElementSibling'].nodeName.toUpperCase() === 'TH')
              {
                replaceCell = pEditor.iFrameDoc.createElement('TH');
                parentTagTable.rows[i].replaceChild(replaceCell, newCell);
                newCell = replaceCell;
              }

              tuningNewCell(false, i, currentCellIndex);
            }
          }
          else
          {
            if (parentTagTR.cells.length > 1)
            {
              newCursorPointCell = (currentCellIndex === parentTagTR.cells.length - 1) ? currentCellIndex - 1 : currentCellIndex + 1;
              pEditor.range.setCursorPoint(parentTagTR.cells[newCursorPointCell], false, currentSelection, currentRange);
            }

            isTableNoCells = true;

            for (i = 0; i < parentTagTable.rows.length; i++)
            {
              if (parentTagTable.rows[i].cells[currentCellIndex])
              {
                parentTagTable.rows[i].deleteCell(currentCellIndex);
              }

              if (parentTagTable.rows[i].cells.length)
              {
                isTableNoCells = false;
              }
            }

            if (isTableNoCells)
            {
              parentTagTable.parentNode.removeChild(parentTagTable);
            }
            else
            {
              pEditor.helpers.fixers.setFixGeckoTables({isBoth: true, newTable: parentTagTable});
              pEditor.undoRedo.isStopSaveUndo = true;
              pEditor.contentChecker.setExcludeWordCheck();
            }
          }
        }
      }

      if (!BEditor.browser.isIE)
      {
        parentTagTable.style.overflow = 'hidden';
        setTimeout(function() { parentTagTable.style.overflow = 'visible'; setTimeout(function() { parentTagTable.style.overflow = ''; pEditor.undoRedo.saveUndoDo(); pEditor.undoRedo.isStopSaveUndo = false; }, 7); }, 7);
      }
      else
      {
        pEditor.undoRedo.isStopSaveUndo = false;
      }
    }

    function collectStyles (isRowAdding)
    {
      var i;
      var fromCell;
      stylesList.length = 0;

      if (isRowAdding)
      {
        for (i = 0; i < parentTagTable.rows[currentRowIndex].cells.length; i++)
        {
          stylesList[i] = {};
          fromCell = parentTagTable.rows[currentRowIndex].cells[i];

          if (BEditor.browser.isIE)
          {
            stylesList[i].style = fromCell.style.cssText;
          }
          else
          {
            stylesList[i].style = fromCell.getAttribute('style', 0);
          }

          stylesList[i].width = (fromCell.width != null) ? fromCell.width : '';
          stylesList[i].height = (parentTag.height != null) ? parentTag.height : '';
          stylesList[i].bordercolor = (fromCell.bordercolor != null) ? fromCell.bordercolor : '';
          stylesList[i].bgcolor = (fromCell.bgcolor != null) ? fromCell.bgcolor : '';
          stylesList[i].background = (fromCell.background != null) ? fromCell.background : '';
          stylesList[i].align = (fromCell.align != null) ? fromCell.align : '';
          stylesList[i].valign = (fromCell.valign != null) ? fromCell.valign : '';
        }
      }
      else
      {
        for (i = 0; i < parentTagTable.rows.length; i++)
        {
          stylesList[i] = {};
          fromCell = (parentTagTable.rows[i].cells[currentCellIndex]) ? parentTagTable.rows[i].cells[currentCellIndex] : parentTagTable.rows[i].cells[parentTagTable.rows[i].cells.length - 1];

          if (BEditor.browser.isIE)
          {
            stylesList[i].style = fromCell.style.cssText;
          }
          else
          {
            stylesList[i].style = fromCell.getAttribute('style', 0);
          }

          stylesList[i].width = (parentTag.width != null) ? parentTag.width : '';
          stylesList[i].height = (fromCell.height != null) ? fromCell.height : '';
          stylesList[i].bordercolor = (fromCell.bordercolor != null) ? fromCell.bordercolor : '';
          stylesList[i].bgcolor = (fromCell.bgcolor != null) ? fromCell.bgcolor : '';
          stylesList[i].background = (fromCell.background != null) ? fromCell.background : '';
          stylesList[i].align = (fromCell.align != null) ? fromCell.align : '';
          stylesList[i].valign = (fromCell.valign != null) ? fromCell.valign : '';
        }
      }
    }

    function tuningNewCell(isRowAdding, rowIndex, cellIndex)
    {
      var fromInCell,
          fromStyleTD;

      if (isRowAdding)
      {
        fromInCell = (stylesList[cellIndex]) ? stylesList[cellIndex] : stylesList[stylesList.length - 1];
      }
      else
      {
        fromInCell = (stylesList[rowIndex]) ? stylesList[rowIndex] : stylesList[stylesList.length - 1];
      }

      if (parentTagTable.rows[rowIndex] && parentTagTable.rows[rowIndex].cells[cellIndex])
      {
        fromStyleTD = parentTagTable.rows[rowIndex].cells[cellIndex];
      }

      if (BEditor.browser.isIE)
      {
        newCell.style.cssText = fromInCell.style;
      }
      else
      {
        newCell.setAttribute('style', fromInCell.style, 0);
      }

      newCell.width = fromInCell.width;
      newCell.height = fromInCell.height;
      newCell.bordercolor = fromInCell.bordercolor;
      newCell.bgcolor = fromInCell.bgcolor;
      newCell.background = fromInCell.background;
      newCell.align = fromInCell.align;
      newCell.valign = fromInCell.valign;

      newCell.innerHTML = '&nbsp;';
    }

    function getRealCellsCount()
    {
      var realCellsCount = 0;

      for (i = 0; i < parentTagTR.cells.length; i++)
      {
        currentColspan = parentTagTR.cells[i].getAttribute('colspan', 0);
        realCellsCount += (currentColspan) ? currentColspan * 1 : 1;
      }

      return realCellsCount;
    }
  };


  function setTableBorderAndBackground (pButton, params)
  {
    var i, n;

    var tCommand = params.command;
    var tValue = params.value;

    if (tCommand.indexOf('Color') != -1)
    {
      tValue = (tValue.toLowerCase() == 'transparent' || tValue.toLowerCase().indexOf('rgb') !== -1 || tValue.indexOf('#') === 0) ? tValue : '#' + tValue;
    }

    var parentTag = params.parentTag || null,
        parentTagTR,
        parentTagTable;
    var currentRowIndex;
    var currentCellIndex;
    var currentRange = pEditor.range.getCurrent();
    var currentSelection = pEditor.range.selection.getCurrent();

    if (currentRange && currentSelection)
    {
      pEditor.undoRedo.isStopSaveUndo = true;
      pEditor.contentChecker.setExcludeWordCheck();

      if (!parentTag)
      {
        parentTag = pEditor.helpers.element.getParentElementByTagsNames(currentRange, checkThTdTags);
      }

      if (parentTag)
      {
        parentTagTR = parentTag.parentNode;
        parentTagTable = parentTagTR.parentNode;

        while (parentTagTable && parentTagTable.nodeName !== 'TABLE')
        {
          parentTagTable = parentTagTable.parentNode;
        }

        if (!parentTagTable)
        {
          return;
        }

        currentRowIndex = parentTagTR.rowIndex;
        currentCellIndex = parentTag.cellIndex;

        if (tCommand == 'setTableBorderWidth')
        {
          parentTagTable.style.borderStyle = 'solid';

          if (tValue.toLowerCase() == 'none')
          {
            parentTagTable.style.borderWidth = 0;
          }
          else
          {
            parentTagTable.style.borderWidth = tValue;
          }
        }
        else if (tCommand == 'setTableBorderColor')
        {
          parentTagTable.style.borderColor = tValue;
        }
        else if (tCommand == 'setTableRowBorderWidth')
        {
          for (i = 0; i < parentTagTable.rows[currentRowIndex].cells.length; i++)
          {
            parentTagTable.rows[currentRowIndex].cells[i].style.borderTopStyle = 'solid';
            parentTagTable.rows[currentRowIndex].cells[i].style.borderBottomStyle = 'solid';

            if (tValue.toLowerCase() == 'none')
            {
              parentTagTable.rows[currentRowIndex].cells[i].style.borderTopWidth = 0;
              parentTagTable.rows[currentRowIndex].cells[i].style.borderBottomWidth = 0;
            }
            else
            {
              parentTagTable.rows[currentRowIndex].cells[i].style.borderTopWidth = tValue;
              parentTagTable.rows[currentRowIndex].cells[i].style.borderBottomWidth = tValue;
            }
          }
        }
        else if (tCommand == 'setTableRowBorderColor')
        {
          for (i = 0; i < parentTagTable.rows[currentRowIndex].cells.length; i++)
          {
            parentTagTable.rows[currentRowIndex].cells[i].style.borderTopColor = tValue;
            parentTagTable.rows[currentRowIndex].cells[i].style.borderBottomColor = tValue;
          }
        }
        else if (tCommand == 'setTableColumnBorderWidth')
        {
          for (i = 0; i < parentTagTable.rows.length; i++)
          {
            parentTagTable.rows[i].cells[currentCellIndex].style.borderLeftStyle = 'solid';
            parentTagTable.rows[i].cells[currentCellIndex].style.borderRightStyle = 'solid';

            if (tValue.toLowerCase() == 'none')
            {
              parentTagTable.rows[i].cells[currentCellIndex].style.borderLeftWidth = 0;
              parentTagTable.rows[i].cells[currentCellIndex].style.borderRightWidth = 0;
            }
            else
            {
              parentTagTable.rows[i].cells[currentCellIndex].style.borderLeftWidth = tValue;
              parentTagTable.rows[i].cells[currentCellIndex].style.borderRightWidth = tValue;
            }
          }
        }
        else if (tCommand == 'setTableColumnBorderColor')
        {
          for (i = 0; i < parentTagTable.rows.length; i++)
          {
            parentTagTable.rows[i].cells[currentCellIndex].style.borderLeftColor = tValue;
            parentTagTable.rows[i].cells[currentCellIndex].style.borderRightColor = tValue;
          }
        }
        else if (tCommand == 'setTableCellBorderWidth')
        {
          parentTagTable.rows[currentRowIndex].cells[currentCellIndex].style.borderStyle = 'solid';

          if (tValue.toLowerCase() == 'none')
          {
            parentTagTable.rows[currentRowIndex].cells[currentCellIndex].style.borderWidth = 0;
          }
          else
          {
            parentTagTable.rows[currentRowIndex].cells[currentCellIndex].style.borderWidth = tValue;
          }
        }
        else if (tCommand == 'setTableCellBorderColor')
        {
          parentTagTable.rows[currentRowIndex].cells[currentCellIndex].style.borderColor = tValue;
        }
        else if (tCommand == 'setTableAllCellsBorderWidth')
        {
          for (i = 0; i < parentTagTable.rows.length; i++)
          {
            for (n = 0; n < parentTagTable.rows[i].cells.length; n++)
            {
              parentTagTable.rows[i].cells[n].style.borderStyle = 'solid';

              if (tValue.toLowerCase() == 'none')
              {
                parentTagTable.rows[i].cells[n].style.borderWidth = 0;
              }
              else
              {
                parentTagTable.rows[i].cells[n].style.borderWidth = tValue;
              }
            }
          }
        }
        else if (tCommand == 'setTableAllCellsBorderColor')
        {
          for (i = 0; i < parentTagTable.rows.length; i++)
          {
            for (n = 0; n < parentTagTable.rows[i].cells.length; n++)
            {
              parentTagTable.rows[i].cells[n].style.borderColor = tValue;
            }
          }
        }
        else if (tCommand == 'setTableRowBackgroundColor')
        {
          for (i = 0; i < parentTagTable.rows[currentRowIndex].cells.length; i++)
          {
            parentTagTable.rows[currentRowIndex].cells[i].style.backgroundColor = (tValue.toLowerCase() == 'transparent') ? 'transparent' : tValue;
          }
        }
        else if (tCommand == 'setTableColumnBackgroundColor')
        {
          for (i = 0; i < parentTagTable.rows.length; i++)
          {
            parentTagTable.rows[i].cells[currentCellIndex].style.backgroundColor = (tValue.toLowerCase() == 'transparent') ? 'transparent' : tValue;
          }
        }
        else if (tCommand == 'setTableCellBackgroundColor')
        {
          parentTagTable.rows[currentRowIndex].cells[currentCellIndex].style.backgroundColor = (tValue.toLowerCase() == 'transparent') ? 'transparent' : tValue;
        }
        else if (tCommand == 'setTableAllCellsBackgroundColor')
        {
          for (i = 0; i < parentTagTable.rows.length; i++)
          {
            for (n = 0; n < parentTagTable.rows[i].cells.length; n++)
            {
              parentTagTable.rows[i].cells[n].style.backgroundColor = (tValue.toLowerCase() === 'transparent') ? 'transparent' : tValue;
            }
          }
        }
      }

      if (!params.isStaticCall)
      {
        if (!BEditor.browser.isIE)
        {
          pEditor.helpers.fixers.setFixGeckoTables({isBoth: true, newTable: parentTagTable});
          pEditor.undoRedo.isStopSaveUndo = true;
          pEditor.contentChecker.setExcludeWordCheck();
          parentTagTable.style.overflow = 'hidden';
          setTimeout(function() { parentTagTable.style.overflow = 'visible'; setTimeout(function() { parentTagTable.style.overflow = ''; pEditor.undoRedo.saveUndoDo(); pEditor.undoRedo.isStopSaveUndo = false; }, 7); }, 7);
        }
        else
        {
          pEditor.undoRedo.isStopSaveUndo = false;
        }
      }
    }
  }


  this.setTableAlignment = (pButton, params) =>
  {
    var i;

    var tCommand = params.command;
    var tValue = params.value;

    var parentTag, parentTagTR, parentTagTable;
    var currentRowIndex;
    var currentCellIndex;
    var currentRange = pEditor.range.getCurrent();
    var currentSelection = pEditor.range.selection.getCurrent();

    if (currentRange && currentSelection)
    {
      pEditor.undoRedo.isStopSaveUndo = true;
      pEditor.contentChecker.setExcludeWordCheck();

      parentTag = pEditor.helpers.element.getParentElementByTagsNames(currentRange, checkThTdTags);

      if (parentTag)
      {
        parentTagTR = parentTag.parentNode;
        parentTagTable = pEditor.helpers.element.getParentElementByTagsNames(currentRange, checkTableTag);
        currentRowIndex = parentTagTR.rowIndex;
        currentCellIndex = parentTag.cellIndex;

        if (tCommand === 'setTableAlignment')
        {
          if (tValue.toLowerCase() === 'none')
          {
            parentTagTable.removeAttribute('align');
          }
          else
          {
            parentTagTable.setAttribute('align', tValue, 0);
          }

          pEditor.helpers.fixers.setFixGeckoTables({isBoth: true, newTable: parentTagTable});
          pEditor.undoRedo.isStopSaveUndo = true;
          pEditor.contentChecker.setExcludeWordCheck();
        }
        else if (tCommand === 'setTableRowHorizontalAlign')
        {
          for (i = 0; i < parentTagTable.rows[currentRowIndex].cells.length; i++)
          {
            parentTagTable.rows[currentRowIndex].cells[i].setAttribute('align', tValue, 0);
          }
        }
        else if (tCommand === 'setTableRowVerticalAlign')
        {
          for (i = 0; i < parentTagTable.rows[currentRowIndex].cells.length; i++)
          {
            parentTagTable.rows[currentRowIndex].cells[i].setAttribute('valign', tValue, 0);
          }
        }
        else if (tCommand === 'setTableColumnHorizontalAlign')
        {
          for (i = 0; i < parentTagTable.rows.length; i++)
          {
            parentTagTable.rows[i].cells[currentCellIndex].setAttribute('align', tValue, 0);
          }
        }
        else if (tCommand === 'setTableColumnVerticalAlign')
        {
          for (i = 0; i < parentTagTable.rows.length; i++)
          {
            parentTagTable.rows[i].cells[currentCellIndex].setAttribute('valign', tValue, 0);
          }
        }
        else if (tCommand === 'setTableCellHorizontalAlign')
        {
          parentTagTable.rows[currentRowIndex].cells[currentCellIndex].setAttribute('align', tValue, 0);
        }
        else if (tCommand === 'setTableCellVerticalAlign')
        {
          parentTagTable.rows[currentRowIndex].cells[currentCellIndex].setAttribute('valign', tValue, 0);
        }
      }

      if (!params.isStaticCall)
      {
        if (!BEditor.browser.isIE)
        {
          parentTagTable.style.overflow = 'hidden';
          setTimeout(function() { parentTagTable.style.overflow = 'visible'; setTimeout(function() { parentTagTable.style.overflow = ''; pEditor.undoRedo.saveUndoDo(); pEditor.undoRedo.isStopSaveUndo = false; }, 7); }, 7);
        }
        else
        {
          pEditor.undoRedo.isStopSaveUndo = false;
        }
      }
    }
  };


  function setTableSizeAndPadding (pButton, params)
  {
    var i;

    var tCommand = params.command;
    var tValue = params.value;

    var parentTag, parentTagTR, parentTagTable;
    var currentRowIndex;
    var currentCellIndex;
    var currentRange = pEditor.range.getCurrent();
    var currentSelection = pEditor.range.selection.getCurrent();

    if (currentRange && currentSelection)
    {
      pEditor.undoRedo.isStopSaveUndo = true;
      pEditor.contentChecker.setExcludeWordCheck();

      parentTag = pEditor.helpers.element.getParentElementByTagsNames(currentRange, checkThTdTags);

      if (parentTag)
      {
        parentTagTR = parentTag.parentNode;
        parentTagTable = pEditor.helpers.element.getParentElementByTagsNames(currentRange, checkTableTag);
        currentRowIndex = parentTagTR.rowIndex;
        currentCellIndex = parentTag.cellIndex;

        if (tCommand == 'setTableSizeWidth')
        {
          if (tValue.toLowerCase() == 'auto')
          {
            parentTagTable.removeAttribute('width');
          }
          else
          {
            parentTagTable.setAttribute('width', tValue);
          }
        }
        else if (tCommand == 'setTableSizeHeight')
        {
          if (tValue.toLowerCase() == 'auto')
          {
            parentTagTable.removeAttribute('height');
          }
          else
          {
            parentTagTable.setAttribute('height', tValue);
          }
        }
        else if (tCommand == 'setTableRowSizeHeight')
        {
          for (i = 0; i < parentTagTable.rows[currentRowIndex].cells.length; i++)
          {
            if (tValue.toLowerCase() == 'auto')
            {
              parentTagTable.rows[currentRowIndex].cells[i].removeAttribute('height');
            }
            else
            {
              parentTagTable.rows[currentRowIndex].cells[i].setAttribute('height', tValue);
            }
          }
        }
        else if (tCommand == 'setTableColumnSizeWidth')
        {
          for (i = 0; i < parentTagTable.rows.length; i++)
          {
            if (tValue.toLowerCase() == 'auto')
            {
              parentTagTable.rows[i].cells[currentCellIndex].removeAttribute('width');
            }
            else
            {
              parentTagTable.rows[i].cells[currentCellIndex].setAttribute('width', tValue);
            }
          }
        }
        else if (tCommand == 'setTableCellsPadding')
        {
          if (tValue.toString().toLowerCase() == 'none')
          {
            parentTagTable.setAttribute('cellpadding', '0');
          }
          else
          {
            parentTagTable.setAttribute('cellpadding', tValue);
          }
        }
      }

      if (!params.isStaticCall)
      {
        if (!BEditor.browser.isIE)
        {
          parentTagTable.style.overflow = 'hidden';
          setTimeout(function() { parentTagTable.style.overflow = 'visible'; setTimeout(function() { parentTagTable.style.overflow = ''; pEditor.undoRedo.saveUndoDo(); pEditor.undoRedo.isStopSaveUndo = false; }, 7); }, 7);
        }
        else
        {
          pEditor.undoRedo.isStopSaveUndo = false;
        }
      }
    }
  }


  function getCurrentTableTdValues ()
  {
    var parentTag,
        parentTagTable;
    var currentValues = {};
    var currentRange = pEditor.range.getCurrent();
    var currentSelection = pEditor.range.selection.getCurrent();

    currentValues.isValid = false;

    if (currentRange && currentSelection)
    {
      parentTagTable = pEditor.helpers.element.getParentElementByTagsNames(currentRange, checkTableTag);
      parentTag = pEditor.helpers.element.getParentElementByTagsNames(currentRange, checkThTdTags);

      if (parentTagTable && parentTag)
      {
        currentValues.isValid = true;

        currentValues.tableWidth = parentTagTable.getAttribute('width', 0);

        if (currentValues.tableWidth)
        {
          currentValues.tableWidth += (currentValues.tableWidth.indexOf('%') == -1) ? 'px' : '';
        }
        else
        {
          currentValues.tableWidth = 'auto';
        }

        currentValues.tableHeight = parentTagTable.getAttribute('height', 0);

        if (currentValues.tableHeight)
        {
          currentValues.tableHeight += (currentValues.tableHeight.indexOf('%') == -1) ? 'px' : '';
        }
        else
        {
          currentValues.tableHeight = 'auto';
        }

        currentValues.tableCellPadding = parentTagTable.getAttribute('cellpadding', 0);

        currentValues.tdWidth = parentTag.getAttribute('width', 0);
        currentValues.tdHeight = parentTag.getAttribute('height', 0);

        currentValues.tableBorderLeftWidth = parentTagTable.style.borderLeftWidth;
        currentValues.tableBorderRightWidth = parentTagTable.style.borderRightWidth;
        currentValues.tableBorderTopWidth = parentTagTable.style.borderTopWidth;
        currentValues.tableBorderBottomWidth = parentTagTable.style.borderBottomWidth;

        currentValues.tableBorderLeftColor = parentTagTable.style.borderLeftColor;
        currentValues.tableBorderRightColor = parentTagTable.style.borderRightColor;
        currentValues.tableBorderTopColor = parentTagTable.style.borderTopColor;
        currentValues.tableBorderBottomColor = parentTagTable.style.borderBottomColor;

        currentValues.borderLeftWidth = parentTag.style.borderLeftWidth;
        currentValues.borderRightWidth = parentTag.style.borderRightWidth;
        currentValues.borderTopWidth = parentTag.style.borderTopWidth;
        currentValues.borderBottomWidth = parentTag.style.borderBottomWidth;

        currentValues.borderLeftColor = parentTag.style.borderLeftColor;
        currentValues.borderRightColor = parentTag.style.borderRightColor;
        currentValues.borderTopColor = parentTag.style.borderTopColor;
        currentValues.borderBottomColor = parentTag.style.borderBottomColor;

        currentValues.backgroundColor = parentTag.style.backgroundColor;
      }
    }

    return currentValues;
  }


  this.openTableMoreDialog = (pButton, params) =>
  {
    var currentValues = getCurrentTableTdValues();
    var sCommand = params.command;
    var sTitle = params.title;
    var winWidth, winHeight;

    pEditor.pDialog = pButton.getDialog();

    if (!pEditor.pDialog)
      return false;

    pEditor.range.save();

    if (currentValues.isValid)
    {
      if (sCommand == 'setTableSizeWidth' || sCommand == 'setTableSizeHeight')
      {
        pEditor.pDialog.setReturnedParameters('tValue', ((currentValues.tableWidth) ? currentValues.tableWidth : 'auto'));
        pEditor.pDialog.setReturnedParameters('tValue1', ((currentValues.tableHeight) ? currentValues.tableHeight : 'auto'));
      }
      else if (sCommand == 'setTableRowSizeHeight')
      {
        pEditor.pDialog.setReturnedParameters('tValue', ((currentValues.tdHeight) ? currentValues.tdHeight : 'auto'));
      }
      else if (sCommand == 'setTableColumnSizeWidth')
      {
        pEditor.pDialog.setReturnedParameters('tValue', ((currentValues.tdWidth) ? currentValues.tdWidth : 'auto'));
      }
      else if (sCommand == 'setTableCellsPadding')
      {
        pEditor.pDialog.setReturnedParameters('tValue', currentValues.tableCellPadding);
      }
      else if (sCommand == 'setTableBorderWidth' || sCommand == 'setTableBorderColor')
      {
        pEditor.pDialog.setReturnedParameters('tValue', currentValues.tableBorderLeftWidth);
        pEditor.pDialog.setReturnedParameters('tValue1', BEditor.utils.convertColorToHex(currentValues.tableBorderLeftColor));
      }
      else if (sCommand == 'setTableRowBorderWidth' || sCommand == 'setTableRowBorderColor')
      {
        pEditor.pDialog.setReturnedParameters('tValue', currentValues.borderTopWidth);
        pEditor.pDialog.setReturnedParameters('tValue1', BEditor.utils.convertColorToHex(currentValues.borderTopColor));
      }
      else if (sCommand == 'setTableColumnBorderWidth' || sCommand == 'setTableColumnBorderColor')
      {
        pEditor.pDialog.setReturnedParameters('tValue', currentValues.borderLeftWidth);
        pEditor.pDialog.setReturnedParameters('tValue1', BEditor.utils.convertColorToHex(currentValues.borderLeftColor));
      }
      else if (sCommand == 'setTableCellBorderWidth' || sCommand == 'setTableCellBorderColor')
      {
        pEditor.pDialog.setReturnedParameters('tValue', currentValues.borderLeftWidth);
        pEditor.pDialog.setReturnedParameters('tValue1', BEditor.utils.convertColorToHex(currentValues.borderLeftColor));
      }
      else if (sCommand == 'setTableAllCellsBorderWidth' || sCommand == 'setTableAllCellsBorderColor')
      {
        pEditor.pDialog.setReturnedParameters('tValue', currentValues.borderLeftWidth);
        pEditor.pDialog.setReturnedParameters('tValue1', BEditor.utils.convertColorToHex(currentValues.borderLeftColor));
      }
      else if (sCommand == 'setTableRowBackgroundColor' || sCommand == 'setTableColumnBackgroundColor' || sCommand == 'setTableCellBackgroundColor' || sCommand == 'setTableAllCellsBackgroundColor')
      {
        pEditor.pDialog.setReturnedParameters('tValue', BEditor.utils.convertColorToHex(currentValues.backgroundColor));
      }

      switch (sCommand)
      {
        case 'setTableBorderWidth':
        case 'setTableRowBorderWidth':
        case 'setTableColumnBorderWidth':
        case 'setTableCellBorderWidth':
        case 'setTableAllCellsBorderWidth':
          sTitle += ' and color';
          winWidth = (BEditor.browser.isIE) ? 495 : 483;
          winHeight = 250;
          break;

        case 'setTableBorderColor':
        case 'setTableRowBorderColor':
        case 'setTableColumnBorderColor':
        case 'setTableCellBorderColor':
        case 'setTableAllCellsBorderColor':
          sTitle += ' and width';
          winWidth = (BEditor.browser.isIE) ? 495 : 483;
          winHeight = 250;
          break;

        case 'setTableSizeWidth':
          sTitle += ' and height';
          winWidth = 400;
          winHeight = 170;
          break;

        case 'setTableSizeHeight':
          sTitle += ' and width';
          winWidth = 400;
          winHeight = 170;
          break;

        case 'setTableRowSizeHeight':
          winWidth = 250;
          winHeight = 170;
          break;

        case 'setTableColumnSizeWidth':
          winWidth = 250;
          winHeight = 170;
          break;

        case 'setTableCellsPadding':
          winWidth = 250;
          winHeight = 170;
          break;

        default:
          winWidth = (BEditor.browser.isIE) ? 495 : 483;
          winHeight = 250;
          break;
      }
    }

    pEditor.pDialog.setReturnedParameters('sCommand', sCommand);
    pEditor.pDialog.setReturnedParameters('sTitle', sTitle);
    pEditor.pDialog.openWindow(function() { pEditor.pThis.execCommand(pButton, 'tableMoreDialogHandler'); }, function() { pEditor.closeDialog(pEditor.pDialog); }, null, null, null, winWidth, winHeight, sTitle);

    pEditor.afterOpenDialog();
  };


  function tableMoreDialogHandler (pButton)
  {
    var pParameters, sCommand, sCommand1, tValue, tValue1;

    if (pEditor.pDialog)
    {
      pParameters = pEditor.pDialog.getReturnedParameters();

      if (pParameters)
      {
        sCommand = pParameters.sCommand;
        sCommand1 = pParameters.sCommand1;
        tValue = pParameters.tValue;
        tValue1 = pParameters.tValue1;
      }

      pEditor.closeDialog();

      if (sCommand.indexOf('Border') != -1 || sCommand.indexOf('Background') != -1)
      {
        if (sCommand && tValue != null)
        {
          setTableBorderAndBackground(pButton, {command: sCommand, value: tValue});
        }

        if (sCommand1 && tValue1 != null)
        {
          setTableBorderAndBackground(pButton, {command: sCommand1, value: tValue1});
        }
      }
      else if (sCommand.indexOf('Size') != -1 || sCommand.indexOf('Padding') != -1)
      {
        if (sCommand && tValue != null)
        {
          setTableSizeAndPadding(pButton, {command: sCommand, value: tValue});
        }

        if (sCommand1 && tValue1 != null)
        {
          setTableSizeAndPadding(pButton, {command: sCommand1, value: tValue1});
        }
      }
    }
  }


  function queryStateTablesBorders(pButton, command)
  {
    return (pEditor.iFrameDoc.body.className && pEditor.iFrameDoc.body.className.indexOf('controlTablesBordersInEditor') != -1);
  }


  this.showHideTablesBorders = (pButton) =>
  {
    var nextYear = new Date();
    nextYear.setFullYear(nextYear.getFullYear() + 1);

    if (queryStateTablesBorders(pButton))
    {
      pEditor.iFrameDoc.body.className = pEditor.iFrameDoc.body.className.replace(/(.*?)\s?controlTablesBordersInEditor(.*?)/, '$1$2');
      document.cookie = 'ShowTablesBordersInEditor=0;expires=' + (nextYear.toGMTString()) + ';path=/';
    }
    else
    {
      pEditor.iFrameDoc.body.className = ((pEditor.iFrameDoc.body.className) ? pEditor.iFrameDoc.body.className + ' ' : '') + 'controlTablesBordersInEditor';
      document.cookie = 'ShowTablesBordersInEditor=1;expires=' + (nextYear.toGMTString()) + ';path=/';
    }

    if (showHideTablesBordersButtonStateTM) clearTimeout(showHideTablesBordersButtonStateTM);
    showHideTablesBordersButtonStateTM = setTimeout(pButton.refreshState, 137);
  };


  this.queryStateTablesBorders = queryStateTablesBorders;
  this.setTableBorderAndBackground = setTableBorderAndBackground;
  this.setTableSizeAndPadding = setTableSizeAndPadding;
  this.tableMoreDialogHandler = tableMoreDialogHandler;
}